import { AppContent, cn } from "twyne-new.ui"

const SIDEBAR_WIDTHS = { 60: 240, 72: 288, 96: 384, 112: 448 }

export default function Sidebar({ children, size = '60', open, className, style }) {
  return <>
    <div className={cn('h-full z-10 relative', open ? 'block' : 'hidden', className)} style={{ width: SIDEBAR_WIDTHS[size] ?? SIDEBAR_WIDTHS[60], ...style }}>
      <div className='w-full h-full twy-bg-base-accent rounded-xs p-2 shadow-[0_0_10px_rgba(0,0,0,0.13)] [clip-path:inset(0_-20px)]'>
        <div className='flex h-full'>
          <AppContent>
            {children}
          </AppContent>
        </div>
      </div>
    </div>
  </>
}
